import { useContext, useEffect } from "react";

import { createError, parseGraphQLError } from "utils";

import { useChargebeeJS } from "components/Chargebee";

import { ToasterContext } from "scenes/Hubly/components/Workspace/Provider";

import { usePortalSession } from "./usePortalSession";

export function useBillingPortal(onOpened) {
  const { fireError } = useContext(ToasterContext);
  const portalSession = usePortalSession();
  const chargebeeJs = useChargebeeJS();

  useEffect(() => {
    const createErrorObj = (error) => {
      return createError({
        ...parseGraphQLError(error),
        name: "useBillingPortal",
        defaultMessage:
          "Something went wrong on our end. Please try again later.",
      });
    };

    if (portalSession.error && !portalSession.loading) {
      const err = createErrorObj(portalSession.error);
      fireError(err.message, err);
    } else if (chargebeeJs.error && !chargebeeJs.loading) {
      fireError(
        "Billing Portal has failed to load, Please try again later",
        chargebeeJs.error
      );
    }
  }, [fireError, chargebeeJs, portalSession]);

  useEffect(() => {
    if (
      !portalSession.loading &&
      !portalSession.error &&
      !chargebeeJs.loading &&
      !chargebeeJs.error &&
      portalSession.data?.instance
    ) {
      const cbInstance = window.Chargebee.getInstance();

      cbInstance.setPortalSession(async () => {
        return portalSession.data.instance;
      });

      cbInstance.createChargebeePortal().open({
        close: () => {
          cbInstance.logout();
        },
      });

      onOpened();
    }
  }, [onOpened, portalSession, chargebeeJs]);

  return {
    loading: portalSession.loading || chargebeeJs.loading,
    openPortal: portalSession.reloadData,
  };
}

export default useBillingPortal;
